<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" v-if="itemsRoles">
              <label class="label text-secondary">Rol</label>
              <select 
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="user.idRole" 
                @change="clearError('companyId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option :value="item.id" v-for="(item, i) of itemsRoles"  :key="i" >{{item.name}}</option> 
              </select>
              <div class="input-error">{{ errors.idRole }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Username (correo)</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el username"
                v-model="user.email"
                @input="clearError('email')"
              />
              <div class="input-error">{{ errors.email }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nombres</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el nombre del usuario"
                v-model="user.firstName"
                @input="clearError('firstName')"
              />
              <div v-if="errors.firstName"  class="input-error">{{ errors.firstName }}</div> 
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Apellidos</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el apellido del usuario"
                v-model="user.lastName"
                @input="clearError('lastName')"
              />
              <div v-if="errors.lastName"  class="input-error">{{ errors.lastName }}</div> 
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">

              <RouterLink to="/users" > 
                <button type="button" class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4" >
                  Cancelar
                </button>
              </RouterLink>
              <button class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4" type="submit" :disabled="isLoading" >
                  <span v-if="!isLoading">{{user.id == 0 ? 'Crear Usuario' : 'Actualizar Usuario'}}</span>
                  <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="isLoading"></span>
                  <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { userSchema } from "@/schemas/userSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from '@/services/api';
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from 'vue-router' 

export default defineComponent({
  name: "CreateUser",
  components: {},
  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter()
    const isLoading = ref(false);

    const itemsRoles = ref<any[]>([]);
    const user = ref({
        id: 0,
				idRole:null,
				email: null,
        firstName: null,
        lastName: null
		}); 
    const errors = ref<Record<string, string>>({});

    onMounted(async () => {
      await getRoles();
      var idUser = route.params.id;
      if(idUser){
        await getUserById(idUser);
      }
    });

    const getRoles = async() => {
        try {
          const response = await api.get(`/common/roles`);
          itemsRoles.value = response.data;

        }catch(ex){
          console.error(ex);
        }
    };

    const validateForm = async () => {
    
      try {
        errors.value = {};
        await userSchema.validate(user.value, { abortEarly: false, context: { id: user.value.id }  });
        isLoading.value = true;
        
        await createUser();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " +err)
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = '';
    };
    
    const getUserById = async(id:any) => {
        try {
          const response = await api.get(`/user/${id}`);
          user.value = response.data;
        }catch(ex){
          console.error(ex);
        }
    };

    const createUser = async() => {
        try {

          const response: any = await api.post(`/user`, user.value);

          if(response.data != 0){
            toast.success(`El Usuario fue ${user.value.id == 0 ? "creado" : "actualizado" } con éxito.`, {
              timeout: 2000
            });

            router.push({name: "UsersPage"})
          }

        }catch(ex){
          toast.error("El Usuario no pudo ser creado.", {
            timeout: 2000
          });
          console.error(ex);
        }
        
        
    };
 
    return {
      createUser,
      validateForm,
      clearError,
      user,
      itemsRoles,
      errors,
      isLoading,
    };
  }
});
</script>
